import { SongQueueItem } from '~/modules/song-queue/song-queue';

interface LabelProps {
  next: SongQueueItem;
  secondsLeft: number | null;
}

/**
 * What the primary says once there is a running order: the song it is about to reach, and how long
 * is left. Same on both post-game steps, so the room is told the same thing whichever it is looking
 * at.
 */
export function NextUpLabel({ next, secondsLeft }: LabelProps) {
  const { song } = next;

  return (
    <span className="flex w-full items-center gap-3.5 text-left normal-case" data-test="next-up">
      <span
        className="h-[2.9375rem] w-[5.25rem] shrink-0 rounded-md bg-black/40 bg-cover bg-center"
        style={{ backgroundImage: `url('https://i3.ytimg.com/vi/${song.video}/hqdefault.jpg')` }}
      />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="text-[0.8125rem] font-bold tracking-[.08em] uppercase opacity-65">
          Next up · from the queue
        </span>
        <span className="ph-no-capture truncate text-[1.375rem] font-bold">
          {song.title} <span className="font-normal opacity-70">{song.artist}</span>
        </span>
      </span>
      {secondsLeft !== null && (
        <span className="shrink-0 text-[1.625rem] font-bold tabular-nums" data-test="next-up-countdown">
          {secondsLeft} s
        </span>
      )}
    </span>
  );
}
